<script setup>
import { watch } from 'vue';
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { useRoute } from 'vue-router';
import { provideDropdownContext } from './provider.js';

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);
const route = useRoute();

const closeMenu = () => {
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});

watch(
  () => route.fullPath,
  () => {
    closeMenu();
  }
);
</script>

<template>
  <div v-on-click-outside="closeMenu" class="relative space-y-2">
    <slot name="trigger" :is-open :toggle="() => toggle()" />
    <div v-show="isOpen" class="absolute">
      <slot />
    </div>
  </div>
</template>
